import { Component, Input } from '@angular/core'
import { SeMenuItem } from './menu.component'

@Component({
  standalone: false,
  selector: 'se-menu-item',
  templateUrl: './menu-item.component.html',
})
export class SeMenuItemComponent {

  @Input('se-data-menu-item') menuItem: SeMenuItem

}
